export default "__VITE_ASSET__COpyZR3c__"